import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { ReactComponent as TellyHappy } from '../../images/deprecationmodal/happy.svg';
import { ReactComponent as BlLogo } from '../../images/deprecationmodal/bllogo.svg';
import { ReactComponent as Hands } from '../../images/deprecationmodal/hands.svg';
import { ReactComponent as Chair } from '../../images/deprecationmodal/chair.svg';
import { setShowDeprecationWarning } from '../../stores/actions/user-interface';
import { logOut } from '../../utils/utils';
import colors from '../../utils/colors';

const SplashBackdrop = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	overflow: hidden;
	z-index: 1000;
	color: white;
	background-color: rgba(79, 76, 86, 0.4);
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
`;

const PopupModalBody = styled.div`
	width: 494px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background-color: ${colors.blGrayscale900};
	border-radius: 16px;
	padding: 32px;
`;

const GradientBg = styled.div`
	background: linear-gradient(108.66deg, #FF6AE6 -4.67%, #FFF85C 69.07%, #A6FF79 120.95%);
	padding: 2px;
	width: 100%;
	margin-bottom: 8px;
	border-radius: 12px;
`;

const StyledButton = styled.button`
	background-color: rgb(79, 76, 86);
	padding: 16px 24px;
	border-radius: 99px;
	border: none;
	cursor: pointer;
	margin: 0;
`;

const Header = styled.h4`
	font-size: 20px;
	font-weight: 600;
	margin: 0 auto 0 0;
`;

const Subheader = styled.p`
	font-size: 14px;
	font-weight: 400;
	margin: 24px 0 16px 0;
`;

const Helplink = styled.a`
	color: ${colors.blGrayscale200};
	text-decoration: none;
	font-size: 14px;
	font-weight: 500;
	text-decoration: underline;
	margin: 8px auto 16px 0;
`;

const Backdrop = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	border-radius: 16px;
	background-color: ${colors.blGrayscale800};
	padding: 24px;
	margin-bottom: 24px;
`;

const CustomTitle = styled.h2`
	font-size: 18px;
	font-weight: 600;
	margin: 10px 0 24px 0;
	background-color: ${colors.blGrayscale800};
`;

const ImgContainer = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 8px;
	background: linear-gradient(108.66deg, #FF6AE6 -4.67%, #FFF85C 69.07%, #A6FF79 120.95%);
`;

const PopupModalSubbox = styled.div`
	max-height:60px;
	display: flex;
	align-items: center;
	gap: 16px;
	background-color: rgb(70, 68, 75);
	border-radius: 12px;
	padding: 10px;


	svg:nth-of-type(2) {
		margin-right: auto;
	}
`;

const supergreen = 'rgb(186, 253, 138)';

export default function StandaloneDeprecationWarning() {
	const dispatch = useDispatch();

	const continueAnyways = () => {
		dispatch(setShowDeprecationWarning(false));
	};

	return (
		<SplashBackdrop>
			<PopupModalBody>
				<Header>Please login via "Brandlive"</Header>

				<Subheader>
					The "Custom Destination" login option is being deprecated.
					All functionality, including custom RTMP endpoints are
					supported via the "Brandlive" login portal.
				</Subheader>
				<Helplink target="_blank" href="https://help.brand.live/hc/en-us/articles/20418898694295-Resource-Custom-Destination-Deprecation">Learn More</Helplink>
				<Backdrop>
					<ImgContainer><Chair /></ImgContainer>
					<CustomTitle>
						<span style={{ color: supergreen }}>Greenroom</span> Producer
					</CustomTitle>
					<GradientBg>
						<PopupModalSubbox>
							<ImgContainer><TellyHappy /></ImgContainer>
							<BlLogo />
						</PopupModalSubbox>
					</GradientBg>

					<PopupModalSubbox style={{ width: '100%' }}>
						<div style={{ width: '40px', height: '40px' }}>
							<Hands />
						</div>
						<p style={{ fontWeight: '600', fontSize: '16px' }}>
							Custom Destination
						</p>
					</PopupModalSubbox>
				</Backdrop>
				<div style={{ display: 'flex', marginLeft: 'auto' }}>
					<StyledButton
						style={{ backgroundColor: 'rgb(79, 76, 86)', color: colors.blGrayscale200 }}
						onClick={continueAnyways}
					>
						Enter anyway
					</StyledButton>
					<StyledButton
						style={{ backgroundColor: supergreen, color: colors.blGrayscale1200, marginLeft: '16px' }}
						onClick={() => logOut(window.location.pathname.includes('/producer'))}
					>
						Return to Login
					</StyledButton>
				</div>
			</PopupModalBody>
		</SplashBackdrop>
	);
}
